import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
class EmptyDecoration {
  constructor() {
    this.type = Decoration_Type.UNRECOGNIZED;
  }
  getDecoration() {
    return {};
  }
  fromCustomStyle(_customStyle) {
    return new EmptyDecoration();
  }
  toCustomStyle() {
    return {};
  }
  overrideWith(decoration) {
    return decoration;
  }
}
export {
  EmptyDecoration
};
//# sourceMappingURL=empty-decoration.js.map
